// Generated by purs version 0.15.16
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Lens_Getter from "../Data.Lens.Getter/index.js";
import * as Data_Lens_Internal_Forget from "../Data.Lens.Internal.Forget/index.js";
import * as Data_Lens_Setter from "../Data.Lens.Setter/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Profunctor_Strong from "../Data.Profunctor.Strong/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect.bindEffect);
var traverse_ = /* #__PURE__ */ Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableArray);
var un = /* #__PURE__ */ Data_Newtype.un();
var map = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var map1 = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var discard2 = /* #__PURE__ */ discard(Concur_Core_Types.bindWidget);
var Wire = function (x) {
    return x;
};
var tea = function (dictMonad) {
    var bind2 = Control_Bind.bind(dictMonad.Bind1());
    return function (s) {
        return function (render) {
            return function (update) {
                var go = function (st) {
                    return bind2(render(st))((function () {
                        var $83 = Data_Function.flip(update)(st);
                        return function ($84) {
                            return go($83($84));
                        };
                    })());
                };
                return go(s);
            };
        };
    };
};
var retryUntilLoop = function (dictMonad) {
    var bind2 = Control_Bind.bind(dictMonad.Bind1());
    var pure3 = Control_Applicative.pure(dictMonad.Applicative0());
    return function (p) {
        return function (w) {
            return function (a) {
                return bind2(w(a))(function (a$prime) {
                    var $76 = p(a$prime);
                    if ($76) {
                        return pure3(a$prime);
                    };
                    return retryUntilLoop(dictMonad)(p)(w)(a$prime);
                });
            };
        };
    };
};
var retryUntil = function (dictMonad) {
    var bind2 = Control_Bind.bind(dictMonad.Bind1());
    var pure3 = Control_Applicative.pure(dictMonad.Applicative0());
    return function (p) {
        return function (w) {
            return bind2(w)(function (a) {
                var $77 = p(a);
                if ($77) {
                    return pure3(a);
                };
                return retryUntil(dictMonad)(p)(w);
            });
        };
    };
};
var remoteWidget = function (dictMonoid) {
    var liftEffect = Effect_Class.liftEffect(Concur_Core_Types.monadEffectWidget(dictMonoid));
    return function (dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var bind2 = Control_Bind.bind(Monad0.Bind1());
        var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
        var pure3 = Control_Applicative.pure(Monad0.Applicative0());
        return function (axn) {
            var $$yield = function (remoteCb) {
                return Concur_Core_Types.mkWidget(function (cb) {
                    return function __do() {
                        Effect_Ref.modify_(function (v) {
                            return append(v)([ cb ]);
                        })(remoteCb)();
                        return Effect_Ref.modify_(Data_Array.deleteBy(Unsafe_Reference.unsafeRefEq)(cb))(remoteCb);
                    };
                });
            };
            var render = function (remoteCb) {
                return bind(axn)(function (val) {
                    return liftEffect(bind1(Effect_Ref.read(remoteCb))(traverse_(function (cb) {
                        return cb(new Concur_Core_Types.Completed(val));
                    })));
                });
            };
            return bind2(liftEffect1(Effect_Ref["new"]([  ])))(function (remoteCb) {
                return pure3({
                    "yield": $$yield(remoteCb),
                    render: render(remoteCb)
                });
            });
        };
    };
};
var newtypeWire = {
    Coercible0: function () {
        return undefined;
    }
};
var receive = function (w) {
    return (un(Wire)(w)).receive;
};
var send = function (dictMonadEffect) {
    var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
    return function (dictPlus) {
        return function (w) {
            return function ($85) {
                return liftEffect((un(Wire)(w)).send($85));
            };
        };
    };
};
var $$with = function (dictMonoid) {
    var alt = Control_Alt.alt(Concur_Core_Types.altWidget(dictMonoid));
    var liftEffect = Effect_Class.liftEffect(Concur_Core_Types.monadEffectWidget(dictMonoid));
    return function (wire) {
        return function (f) {
            var go = function (a) {
                return bind(alt(map(Data_Either.Left.create)(f(a)))(map(Data_Either.Right.create)(receive(wire))))(function (res) {
                    return Data_Either.either(pure1)(go)(res);
                });
            };
            return bind(liftEffect((un(Wire)(wire)).value))(function (val) {
                return go(val);
            });
        };
    };
};
var mapWire = function (dictAlt) {
    var map2 = Data_Functor.map(dictAlt.Functor0());
    return function (dictMonadEffect) {
        return function (dictPlus) {
            return function (lens) {
                var lens1 = lens(Data_Lens_Internal_Forget.strongForget);
                var lens2 = lens(Data_Profunctor_Strong.strongFn);
                return function (wire) {
                    var wirerec = un(Wire)(wire);
                    return {
                        value: map1(Data_Lens_Getter.view(lens1))(wirerec.value),
                        send: function (a) {
                            return bind1(wirerec.value)((function () {
                                var $86 = Data_Lens_Setter.set(lens2)(a);
                                return function ($87) {
                                    return wirerec.send($86($87));
                                };
                            })());
                        },
                        receive: map2(Data_Lens_Getter.view(lens1))(wirerec.receive)
                    };
                };
            };
        };
    };
};
var loopState = function (dictMonad) {
    var bind2 = Control_Bind.bind(dictMonad.Bind1());
    var pure3 = Control_Applicative.pure(dictMonad.Applicative0());
    return function (s) {
        return function (f) {
            return bind2(f(s))(function (v) {
                if (v instanceof Data_Either.Left) {
                    return loopState(dictMonad)(v.value0)(f);
                };
                if (v instanceof Data_Either.Right) {
                    return pure3(v.value0);
                };
                throw new Error("Failed pattern match at Concur.Core.Patterns (line 27, column 25 - line 29, column 20): " + [ v.constructor.name ]);
            });
        };
    };
};
var local = function (dictMonoid) {
    var liftEffect = Effect_Class.liftEffect(Concur_Core_Types.monadEffectWidget(dictMonoid));
    return function (ainit) {
        return function (f) {
            return bind(liftEffect(Effect_Ref["new"](ainit)))(function (currentVal) {
                return bind(liftEffect(Effect_Ref["new"](pure2(function (v) {
                    if (v instanceof Concur_Core_Types.Completed) {
                        return Effect_Ref.write(v.value0)(currentVal);
                    };
                    return pure(Data_Unit.unit);
                }))))(function (remoteCb) {
                    var wire = {
                        value: Effect_Ref.read(currentVal),
                        send: function (a) {
                            return bind1(Effect_Ref.read(remoteCb))(traverse_(function (cb) {
                                return cb(new Concur_Core_Types.Completed(a));
                            }));
                        },
                        receive: Concur_Core_Types.mkWidget(function (cb) {
                            return function __do() {
                                Effect_Ref.modify_(function (v) {
                                    return append(v)([ cb ]);
                                })(remoteCb)();
                                return Effect_Ref.modify_(Data_Array.deleteBy(Unsafe_Reference.unsafeRefEq)(cb))(remoteCb);
                            };
                        })
                    };
                    return f(wire);
                });
            });
        };
    };
};
var internalise = function (dictMonoid) {
    var liftEffect = Effect_Class.liftEffect(Concur_Core_Types.monadEffectWidget(dictMonoid));
    return function (dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var bind2 = Control_Bind.bind(Monad0.Bind1());
        var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
        var pure3 = Control_Applicative.pure(Monad0.Applicative0());
        return function (axn) {
            return function (val) {
                var render = function (ref) {
                    var go = function (v) {
                        return bind(axn(v))(function (v$prime) {
                            return discard2(liftEffect(Effect_Ref.write(v$prime)(ref)))(function () {
                                return go(v$prime);
                            });
                        });
                    };
                    return bind(liftEffect(Effect_Ref.read(ref)))(go);
                };
                return bind2(liftEffect1(Effect_Ref["new"](val)))(function (ref) {
                    return pure3(render(ref));
                });
            };
        };
    };
};
export {
    loopState,
    retryUntil,
    retryUntilLoop,
    tea,
    remoteWidget,
    internalise,
    Wire,
    mapWire,
    local,
    send,
    receive,
    $$with as with,
    newtypeWire
};
//# sourceMappingURL=index.js.map
